export default __webpack_public_path__ + "static/rope-dd393248d12af9abcd3439528259514f.png";